import {BASE_API} from "../index";

export const NotificacaoApi = {
  getAll: async (user_uuid, qtd) => {
    let response = await fetch(`${BASE_API}/notificacao`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(
        {
          user_uuid,
          qtd
        }
      )
    })
    return await response.json();
  },

  getAllAdmin: async (user_uuid, pagina, ordem) => {
    let response = await fetch(`${BASE_API}/notificacao/getall`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(
        {
          user_uuid,
          pagina,
          ordem
        }
      )
    })
    return await response.json();
  },

  getAllSearch: async (user_uuid, pagina, search) => {
    let response = await fetch(`${BASE_API}/notificacao/getall?search=${search}`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(
        {
          user_uuid,
          pagina
        }
      )
    })
    return await response.json();
  },

  setView: async (user_uuid, notificacao_uuid) => {
    let response = await fetch(`${BASE_API}/notificacao/view`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(
        {
          user_uuid,
          notificacao_uuid
        }
      )
    })
    return await response.json();
  },

  setDelete: async (user_uuid, notificacao_uuid) => {
    let response = await fetch(`${BASE_API}/notificacao/userdelete`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(
        {
          user_uuid,
          notificacao_uuid
        }
      )
    })
    return await response.json();
  },

  create: async (user_uuid, texto) => {
    let response = await fetch(`${BASE_API}/notificacao/create`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
      },
      body: JSON.stringify(
        {
          user_uuid,
          texto
        }
      )
    })
    return await response.json();
  },

  delete: async (user_uuid, notificacao_uuid) => {
    let response = await fetch(`${BASE_API}/notificacao/delete`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
      },
      body: JSON.stringify(
        {
          user_uuid,
          notificacao_uuid
        }
      )
    })
    return await response.json();
  },

  getQtd: async (user_uuid) => {
    let response = await fetch(`${BASE_API}/notificacao/getqtd`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
      },
      body: JSON.stringify(
        {
          user_uuid
        }
      )
    })
    return await response.json();
  }
}